import React from "react";
import { withStyles } from "@mui/styles";

const styles = (theme) => ({
  errorMessage: {
    color: "#222",
  },
});

function ErrorMessage({ classes, message }) {
  return <div className={classes.errorMessage}>{message}</div>;
}

export default withStyles(styles)(ErrorMessage);
